import { __, sprintf } from '@wordpress/i18n';
import { ToggleControl, TextControl, Notice } from '@wordpress/components';

import PanelBody from '../../../../components/PanelBody';
import Slider from '../../../../components/Slider';
import ButtonGroup from '../../../../components/ButtonGroup';

const SHAPE_OPTIONS = [
  { value: 'circle', label: __('Circle', 'brandy-blocks') },
  { value: 'rounded', label: __('Rounded', 'brandy-blocks') },
];

/**
 * Layout controls: avatar size, overlap, shape, visible count, overflow.
 */
export default function LayoutPanel({ attributes, setAttributes }) {
  const { size, overlap, shape, maxVisible, expandable, overflowPrefix } = attributes;

  return (
    <PanelBody title={__('Layout', 'brandy-blocks')} initialOpen>
      <Slider
        label={__('Avatar size (px)', 'brandy-blocks')}
        value={size}
        onChange={(value) => setAttributes({ size: value })}
        min={24}
        max={96}
      />
      <Slider
        label={__('Overlap (px)', 'brandy-blocks')}
        value={overlap}
        onChange={(value) => setAttributes({ overlap: value })}
        min={0}
        max={40}
      />
      <ButtonGroup
        options={SHAPE_OPTIONS}
        selected={shape}
        onChange={(value) => setAttributes({ shape: value })}
      />
      <Slider
        label={__('Max visible avatars', 'brandy-blocks')}
        value={maxVisible}
        onChange={(value) => setAttributes({ maxVisible: value })}
        min={1}
        max={20}
      />
      <Notice status="info" isDismissible={false}>
        {sprintf(
          /* translators: %d: number of avatars shown before the +N tile. */
          __('The editor shows every avatar. The frontend shows the first %d, then a +N tile.', 'brandy-blocks'),
          maxVisible
        )}
      </Notice>
      <ToggleControl
        label={__('Expand inline on +N click', 'brandy-blocks')}
        checked={!!expandable}
        onChange={(value) => setAttributes({ expandable: value })}
      />
      <TextControl
        label={__('Overflow prefix', 'brandy-blocks')}
        value={overflowPrefix}
        onChange={(value) => setAttributes({ overflowPrefix: value })}
        help={__('Shown before the hidden count, e.g. "+" → "+3".', 'brandy-blocks')}
      />
    </PanelBody>
  );
}
